<template>
  <div>
    <div class="searchArea">
      <div class="search-left">
        <a-input v-model:value="searchName" placeholder="请输入商品名称" allowClear style="width: 200px; margin-right: 10px;" @pressEnter="search" />
        <a-button type="primary" shape="circle" @click="search()">
          <template #icon>
            <SearchOutlined /></template>
        </a-button>
        <a-button style="margin-left: 8px" @click="resetSearch">重置</a-button>
        <a-button type="primary" style="margin-left: 20px" @click="handleAdd">
          <template #icon>
            <PlusOutlined /></template>
          新增商品
        </a-button>
      </div>

    </div>

    <a-table class="ant-table-striped" :columns="columns" :data-source="data" :rowClassName="(record, index) => (index % 2 === 1 ? 'table-striped' : null)" bordered rowKey="id" :pagination="{ pageSize: 10 }" :loading="loading">
      <template #thumbnailUuid="{ record }">
        <div v-if="record.thumbnailUuid" class="thumbnail-wrapper">
          <a-image :src="imageUrl + record.thumbnailUuid" :width="50" :height="50" style="object-fit: cover; border-radius: 4px;" alt="缩略图" />
        </div>
        <span v-else>无图片</span>
      </template>

      <template #status="{ record }">
        <a-tag :color="record.enabled ? 'green' : 'red'">
          {{ record.enabled ? '在售' : '下架' }}
        </a-tag>
      </template>

      <template #operation="{ record }">
        <div class="flex_sa">
          <a-tooltip title="编辑">
            <a @click="handleEdit(record)">
              <FormOutlined />
            </a>
          </a-tooltip>

          <a-popconfirm title="确定要删除此商品吗？" @confirm="handleDelete(record.id)">
            <a-tooltip title="删除" style="margin-left: 12px;">
              <a class="text_danger">
                <DeleteOutlined />
              </a>
            </a-tooltip>
          </a-popconfirm>
        </div>
      </template>
    </a-table>

    <ProductModal v-model:visible="modalVisible" :record="currentRecord" @ok="handleSuccess" />
  </div>
</template>

<script>
// [Style 2.1] Options API
import { SearchOutlined, FormOutlined, DeleteOutlined, PlusOutlined } from "@ant-design/icons-vue";
import { message } from "ant-design-vue";
// 请确保路径与您项目一致
import { GetProductList, DeleteProduct } from "/src/api/shopping.js";
import ProductModal from "../../components/shopping/ProductModal.vue";

export default {
  name: "商品管理", // [Style 2.3.2]
  components: {
    SearchOutlined,
    FormOutlined,
    DeleteOutlined,
    PlusOutlined,
    ProductModal,
  },
  data() {
    return {
      searchName: undefined,
      data: [],
      loading: false,
      imageUrl: '/api/file/img/', // [Style 3.1] 基础图片路径

      // [Style 2.3.10] 弹窗控制
      modalVisible: false,
      currentRecord: {},

      columns: [
        { title: "商品名称", dataIndex: "name", key: "name", width: "20%" },
        {
          title: "缩略图",
          dataIndex: "thumbnailUuid",
          key: "thumbnailUuid",
          width: "10%",
          slots: { customRender: "thumbnailUuid" }
        },
        // [Style 2.2] 健壮性默认值处理建议在API层或此处转换，这里直接展示
        { title: "类型", dataIndex: "category", key: "category", width: "15%" },
        { title: "单位", dataIndex: "packageUnit", key: "packageUnit", width: "10%" },
        { title: "价格", dataIndex: "price", key: "price", width: "10%" },
        { title: "状态", key: "status", width: "10%", slots: { customRender: "status" } },
        { title: "操作", key: "operation", width: "15%", slots: { customRender: "operation" } },
      ],
    };
  },
  mounted() {
    this.search();
  },
  methods: {
    // 重置
    resetSearch() {
      this.searchName = undefined;
      this.search();
    },

    // [Style 2.3.10] 新增：清空当前行数据
    handleAdd() {
      this.currentRecord = {};
      this.modalVisible = true;
    },

    // [Style 2.3.10] 编辑：使用解构赋值创建副本
    handleEdit(record) {
      this.currentRecord = { ...record };
      this.modalVisible = true;
    },

    // [Style 2.3.10] 成功回调
    handleSuccess() {
      this.modalVisible = false;
      this.search(); // 刷新列表
    },

    // 删除
    async handleDelete(id) {
      try {
        // [Style 1.2] DELETE 请求参数包裹
        const res = await DeleteProduct({ id: id });
        if (res.errCode === 0) {
          message.success("删除成功");
          this.search();
        }
      } catch (error) {
        console.error("Delete error:", error);
      }
    },

    // 查询
    async search() {
      this.loading = true;
      const params = {
        name: this.searchName,
      };

      try {
        const res = await GetProductList(params);
        if (res.errCode === 0) {
          this.data = (res.data || []).map((item, index) => ({
            ...item,
            orderIndex: index + 1
          }));
        }
      } catch (error) {
        console.error("Search error:", error);
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>

<style scoped>
/* [Style 2.4] Scoped CSS */
.searchArea {
  display: flex;
  margin-bottom: 20px;
  align-items: center;
  justify-content: space-between; /* 关键：让左右两边分开 */
}

.search-left {
  display: flex;
  align-items: center;
}

.thumbnail-wrapper {
  width: 50px;
  height: 50px;
  margin: 0 auto;
  overflow: hidden;
  border-radius: 4px;
  background-color: #f0f0f0;
  display: flex;
  align-items: center;
  justify-content: center;
}

.flex_sa {
  display: flex;
  align-items: center;
  justify-content: center;
}

.flex_sa a {
  color: rgba(0, 0, 0, 0.88);
  transition: color 0.3s;
  cursor: pointer;
  margin: 0 5px;
}

.flex_sa .text_danger {
  color: #ff4d4f;
}
</style>